<template>
  <div class="navbar">
    <nav>
      <ul>
        <li>
          <router-link @click.native="moveToSection('about')" to>About</router-link>
        </li>
        <li>
          <router-link @click.native="moveToSection('skills')" to>Skills & Services</router-link>
        </li>
        <li>
          <router-link @click.native="moveToSection('projects')" to>Projects</router-link>
        </li>
        <li>
          <router-link @click.native="moveToSection('articles')" to>Articles</router-link>
        </li>
        <li>
          <router-link @click.native="moveToSection('contact')" to>Contact</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  created: function() {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 500) {
        document.querySelector("nav").style.backgroundColor = "#f44030";
        document.querySelector("nav").classList.add("sticky");
      } else {
        document.querySelector("nav").classList.remove("sticky");
        document.querySelector("nav").style.backgroundColor = "#ffffff";
      }
    });
  },
  destroyed: function() {
    window.removeEventListener("scroll");
  },
  methods: {
    moveToSection(section) {
      let header = document.querySelector(".home-header").clientHeight;
      let about = document.querySelector("#about").clientHeight;
      let skills = document.querySelector("#skills").clientHeight;
      let projects = document.querySelector("#projects").clientHeight;
      let articles = document.querySelector("#articles").clientHeight;

      let top = 0;

      if (section === "about") {
        top = header;
      }
      if (section === "skills") {
        top = about + header;
      }
      if (section === "projects") {
        top = header + about + skills;
      }
      if (section === "articles") {
        top = header + about + skills + projects;
      }
      if (section === "contact") {
        top = header + about + skills + projects + articles;
      }

      window.scroll({
        top,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
